/** Formats a consultant hours value with up to two decimal places, e.g. "12.5 h". */
export function formatHours(value?: number | null): string {
  return `${(value ?? 0).toLocaleString(undefined, { maximumFractionDigits: 2 })} h`;
}
